import React from 'react';

import './App.css';
import { AuthProvider } from 'contexts/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { datadogInit } from 'config/datadog';
import ErrorBoundary from 'screens/ErrorBoundary';
import { NavigationWrapper } from 'router/NavigationWrapper';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Router } from 'router';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';

datadogInit();
function App() {
  const queryClient = new QueryClient();
  return (
    <div className="App">
      <ErrorBoundary silent={false}>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <NavigationWrapper>
                <Router />
              </NavigationWrapper>
            </AuthProvider>
            <ReactQueryDevtools initialIsOpen={false}/>
          </QueryClientProvider>
        </BrowserRouter>
        <div id="recaptcha-container"></div>
      </ErrorBoundary>
    </div>
  );
}

export default App;
